import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { PROFILE } from "../data/content";

const links = [
  { to: "/",         label: "Trang chủ", end: true },
  { to: "/blog",     label: "Blog" },
  { to: "/projects", label: "Dự án" },
  { to: "/videos",   label: "Videos" },
  { to: "/resume",   label: "CV" },
{ to: "/feedback", label: "Feedback" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav style={{
      position: "sticky", top: 0, zIndex: 50,
      height: 60,
      background: scrolled ? "rgba(250,250,250,0.85)" : "rgba(250,250,250,0.98)",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
      borderBottom: scrolled ? "1px solid #E4E4E7" : "1px solid transparent",
      transition: "border-color 300ms, background 300ms",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px", height: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>

        {/* Logo */}
        <NavLink to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <div style={{ width: 28, height: 28, borderRadius: 7, background: "#09090B", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontFamily: "'Archivo',sans-serif", fontWeight: 900, fontSize: 13, color: "#fff", letterSpacing: "-0.5px" }}>
              AD
            </span>
          </div>
          <span style={{ fontFamily: "'Archivo',sans-serif", fontWeight: 700, fontSize: 15, color: "#09090B", letterSpacing: "-0.3px" }}>
            {PROFILE.name}
          </span>
        </NavLink>

        {/* Desktop */}
        <div className="nav-desktop" style={{ display: "flex", alignItems: "center", gap: 2 }}>
          {links.map(l => (
            <NavLink key={l.to} to={l.to} end={!!l.end}
              className={({ isActive }) => isActive ? "nav-link-active" : "nav-link"}
            >{l.label}</NavLink>
          ))}
          <div style={{ width: 1, height: 18, background: "#E4E4E7", margin: "0 8px" }} />
          <NavLink to="/contact" style={{ textDecoration: "none" }}>
            <button className="btn-primary" style={{ height: 34, padding: "0 16px", fontSize: 13, borderRadius: 7 }}>
              Liên hệ
            </button>
          </NavLink>
        </div>

        {/* Mobile */}
        <button className="nav-mob-btn" onClick={() => setOpen(v => !v)}
          style={{ display: "none", alignItems: "center", background: "none", border: "none", cursor: "pointer", padding: 4 }}>
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div style={{
          position: "absolute", top: 60, left: 0, right: 0,
          background: "rgba(250,250,250,0.97)", backdropFilter: "blur(16px)",
          borderBottom: "1px solid #E4E4E7",
          padding: "8px 16px 14px",
          display: "flex", flexDirection: "column", gap: 2,
        }}>
          {[...links, { to: "/contact", label: "Liên hệ" }].map(l => (
            <NavLink key={l.to} to={l.to} end={!!l.end} onClick={() => setOpen(false)}
              className={({ isActive }) => isActive ? "nav-link-active" : "nav-link"}
              style={{ display: "block", padding: "10px 12px" }}
            >{l.label}</NavLink>
          ))}
        </div>
      )}
    </nav>
  );
}
